import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import store, { RootState } from "store";
import history from "libs/history";
import { get } from "lodash";

window.addEventListener("online", () => {
  history.push("/chat");
});
window.addEventListener("offline", () => history.push("/disconnect"));

window.addEventListener("error", (e) => {
  if (/Loading chunk [\d]+ failed/.test(e.message)) {
    window.location.reload();
  }
});

interface IInitialState {
  loadingItems: any[];
  loading: boolean;
  loadingCount: number;
}

const initialState: IInitialState = {
  loadingItems: [],
  loading: false,
  loadingCount: 0
};

export const globalSlice = createSlice({
  name: "global",
  initialState: initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<any>) => {
      const status = get(action, "payload.status");
      if (typeof status !== "boolean") return;
      // console.log(state.loadingCount, action.payload.status);
      if (status) {
        state.loadingCount += 1;
        state.loading = action.payload as any;
      } else if (state.loadingCount - 1 > 0) {
        state.loadingCount -= 1;
      } else {
        state.loadingCount -= 1;
        state.loading = action.payload as any;
      }
    },
  },
});

export const mapGlobalLoading = (state: RootState) => state.global.loading;

export const setLoadingDirect = (loading: boolean) => {
  const dispatch = store.dispatch;
  dispatch(setLoading(loading));
};

export const { setLoading } = globalSlice.actions;
export default globalSlice.reducer;
